import React, { useEffect } from 'react';
import { Card } from 'antd';
import PurchaseList from '../../components/Purchase/PurchaseList';
import { usePurchase } from '../../store/purchaseContext';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const PurchaseListPage: React.FC = () => {
    const { fetchPurchases } = usePurchase();
    const navigate = useNavigate();

    useEffect(() => {
        fetchPurchases();
    }, []);

    // OnEdit now navigates to form with purchase id
    const handleEdit = (purchase: any) => {
        navigate(`/purchase/form/${purchase.id || purchase._id}`);
    };

    return (
        <div style={{ padding: 16 }}>
            <Card title={t('purchaseList')} variant="outlined">
                <PurchaseList onEdit={handleEdit} />
            </Card>
        </div>
    );
};

export default PurchaseListPage;
